

window.addEventListener("DOMContentLoaded", () => {
    const confirmCloseButtons = document.querySelectorAll('*[data-action="confirm-close"]');

    confirmCloseButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            confirmAddPopup.classList.remove('Open');
        });
    });
});

const confirmAddPopup = document.querySelector('#Confirm_Add');

const CONFIRM_SECTION_ID = 'confirm';

window.addEventListener('confirm:open', async function(e) {
    const itemKey = e.detail.key;
    // Fetch product details
    const confirmSectionJSON = await getConfirmSection(itemKey);
    // Parse the html
    const parser = new DOMParser();
    const doc = parser.parseFromString(confirmSectionJSON[CONFIRM_SECTION_ID], 'text/html');
    const confirmSections = doc.querySelectorAll('.Confirm_Add_Product');
    // Get section with matching key
    const confirmSection = Array.from(confirmSections).find(section => section.dataset.key === itemKey);

    confirmAddPopup.querySelector('.Confirm_Add_Product_Container').innerHTML = confirmSection.innerHTML;
    confirmAddPopup.classList.add('Open');
    window.dispatchEvent(new CustomEvent('global:align'));
});

window.addEventListener('confirm:close', function() {
    confirmAddPopup.classList.remove('Open');
});

async function getConfirmSection(key){
    return await fetch(`cart?sections=${CONFIRM_SECTION_ID}&line_key=${key}`)
        .then(response => response.json());
}